<template>
  <!-- スカウトヘッダー -->
  <div class="modal-scout">
    <div class="scout-message-wrapper" v-if="!updateSkFlg">
      <div class="scout-message">
        <div>{{widgetData.scout_message}}</div>
      </div>
      <div class="email-form">
        <p class="form-name">メールアドレス</p>
        <div class="control">
          <input v-model="email" class="input" type="email" placeholder="例) xxx@example.com">
        </div>
      </div>
      <div class="btn-message">
        <button
          class="button is-fullwidth is-link"
          @click="scoutEmailParam"
          :disabled="!email">送信</button>
      </div>
    </div>
    <div class="send-box" v-if="updateSkFlg">
      <div class="scout-message">
        <p>ご入力ありがとうございました。</p>
        <p>入力いただいたメールアドレス宛にメールをお送りいたしましたので、お手数をおかけいただきますが、ご確認のほどよろしくお願いいたします。</p>
      </div>
      <button class="button is-fullwidth" @click="setOpenForm(false)">チャット画面に戻る</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    updateSkFlg: {
      type: Boolean,
      required: true
    },
    widgetData: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      email: null
    }
  },
  methods: {
    scoutEmailParam () {
      this.$emit('scoutEmailParam', this.email)
    },
    setOpenForm (flg) {
      this.$emit('setOpenForm', flg)
    },
  }
}
</script>

<style lang="scss" scoped>
.modal-scout {
  padding: 16px;
  position: absolute;
  background-color: #fff;
  z-index: 100;
  width: 100%;
  height: 100%;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  display: flex;
  align-items: center;
  .scout-message-wrapper {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-image: url('../../../assets/template/mailback.png');
    background-size: 90%;
    background-position:center center;
    background-repeat: no-repeat;
  }
}
.scout-message {
  text-align: left;
  font-size: medium;
  p {
    margin-bottom: 8px;
  }
  &:last-child p {
    margin-bottom: 0;
  }
  div {
    max-height: 250px;
    overflow-y: auto;
  }
}
.email-form {
  margin: 24px 0;
  width: 100%;
}
.form-name {
  text-align: left;
  font-weight: bold;
}
.btn-message {
  width: 100%;
}
.send-box {
  width: 100%;
  height: 100%;
  background-image: url('../../../assets/template/plane.png');
  background-size: 90%;
  background-position:center center;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
</style>


// WEBPACK FOOTER //
// src/components/ChatWidgetDialog/organisms/ChatDialogScout.vue